import { React, useState, useEffect, useContext } from "react";
import { AppContext } from "../../../../AppStore";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from "react-select";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import MachineProductionStatisticsModal from "../../../../modal/PC/machining/MachineProductionStatisticsModal";
import GridNoRow from "../../../../common/GridNoRow";
import Checkbox from "../../../../common/Checkbox";
import Moment from "moment";
import "moment/locale/ko";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useNavigate, useLocation } from "react-router-dom";

const MachineProductionStatistics = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const appStore = useContext(AppContext);

  const [MenuID, setMenuID] = useState(0);
  const [MenuName, setMenuName] = useState("");
  const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState("N");
  const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState("N");
  const [MenuUpdateYN, setMenuUpdateYN] = useState("N");
  const [MenuDeleteYN, setMenuDeleteYN] = useState("N");

  const [tabID, setTabID] = useState("1");
  const [gridWidth, setGridWidth] = useState("380px");

  const [graphData, setGraphData] = useState([]);
  const [originRows, setOriginRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  const [keyword, setKeyword] = useState({
    start_date: Moment().format("YYYY-MM-01"),
    end_date: appStore.YYYY_MM_DD(),
    machine_id: "", // 설비
    machine_type: "",
    status2: 1, // 기준
  });

  const [machineInfo, setMachineInfo] = useState([]); // 설비 리스트
  const [machineOption, setMachineOption] = useState([]);
  const [status2Option, setStatus2Option] = useState([]);

  const [selectDataID, setSelectDataID] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [graphTitle, setGraphTitle] = useState("");
  const [dataKey, setDataKey] = useState("");
  const [isDetailModalOpen, setDetailModalOpen] = useState(false);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    gijun_name: true,
    gijun_count: true,
  });

  const [FauncYN, setFauncYN] = useState("N");

  useEffect(() => {
    // mount 시 1회
  }, []);

  // 탭/기준 선택될 때마다 컬럼 구성 + 조회 기간 기본값 세팅
  useEffect(() => {
    if (String(keyword.status2) === "1") {
      setGridWidth("705px");
    } else if (String(keyword.status2) === "2") {
      setGridWidth("560px");
    } else if (String(keyword.status2) === "3") {
      setGridWidth("870px");
    }

    if (String(keyword.status2) === "1") {
      // 생산수량
      setColumns([
        {
          field: "viewer",
          headerName: "상세",
          width: 55,
          type: "actions",
          disableClickEventBubbling: true,
          getActions: (params) => [
            <GridActionsCellItem
              icon={<AssignmentIcon color={"primary"} />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                DetailClick(params);
              }}
              label="Viewer"
            />,
          ],
          headerAlign: "center",
          align: "center",
        },
        { field: "id", headerName: "id", width: 0, headerAlign: "center", align: "center" },
        { field: "gijun_date", headerName: "기준일자", width: 105, headerAlign: "center", align: "center" },
        { field: "gijun_month", headerName: "기준년월", width: 105, headerAlign: "center", align: "center" },
        { field: "sum_run_min_str", headerName: "생산시간", width: 85, headerAlign: "center", align: "center" },
        { field: "percent_run_min_str", headerName: "가동율", width: 85, headerAlign: "center", align: "right" },
        { field: "sum_produce_count", headerName: "생산수량", width: 90, headerAlign: "center", align: "right" },
        { field: "sum_produce_complete_count", headerName: "양품수량", width: 90, headerAlign: "center", align: "right" },
        { field: "sum_produce_error_count", headerName: "불량수량", width: 90, headerAlign: "center", align: "right" },
        { field: "produce_error_percent", headerName: "불량율", width: 85, headerAlign: "center", align: "right" },
      ]);
    } else if (String(keyword.status2) === "2") {
      // 프로젝트
      setColumns([
        {
          field: "viewer",
          headerName: "상세",
          width: 55,
          type: "actions",
          disableClickEventBubbling: true,
          getActions: (params) => [
            <GridActionsCellItem
              icon={<AssignmentIcon color={"primary"} />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                DetailClick(params);
              }}
              label="Viewer"
            />,
          ],
          headerAlign: "center",
          align: "center",
        },
        { field: "id", headerName: "id", width: 0, headerAlign: "center", align: "center" },
        { field: "gijun_date", headerName: "기준일자", width: 105, headerAlign: "center", align: "center" },
        { field: "gijun_month", headerName: "기준년월", width: 105, headerAlign: "center", align: "center" },
        { field: "project_name", headerName: "프로젝트", width: 110, headerAlign: "center", align: "center" },
        { field: "sum_produce_count", headerName: "생산수량", width: 90, headerAlign: "center", align: "right" },
        { field: "sum_produce_complete_count", headerName: "양품수량", width: 90, headerAlign: "center", align: "right" },
        { field: "sum_produce_error_count", headerName: "불량수량", width: 90, headerAlign: "center", align: "right" },
      ]);
    } else if (String(keyword.status2) === "3") {
      // 생산품목(실적)
      setColumns([
        {
          field: "viewer",
          headerName: "상세",
          width: 55,
          type: "actions",
          disableClickEventBubbling: true,
          getActions: (params) => [
            <GridActionsCellItem
              icon={<AssignmentIcon color={"primary"} />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                DetailClick(params);
              }}
              label="Viewer"
            />,
          ],
          headerAlign: "center",
          align: "center",
        },
        { field: "id", headerName: "id", width: 0, headerAlign: "center", align: "center" },
        { field: "gijun_date", headerName: "기준일자", width: 105, headerAlign: "center", align: "center" },
        { field: "gijun_month", headerName: "기준년월", width: 105, headerAlign: "center", align: "center" },
        { field: "item_name", headerName: "품목명", width: 150, headerAlign: "center", align: "left" },
        { field: "item_spec", headerName: "규격", width: 200, headerAlign: "center", align: "left" },
        { field: "sum_produce_count", headerName: "생산수량", width: 90, headerAlign: "center", align: "right" },
        { field: "sum_produce_complete_count", headerName: "양품수량", width: 90, headerAlign: "center", align: "right" },
        { field: "sum_produce_error_count", headerName: "불량수량", width: 90, headerAlign: "center", align: "right" },
        { field: "produce_error_percent", headerName: "불량율", width: 80, headerAlign: "center", align: "right" },
      ]);
    } else if (String(keyword.status2) === "4") {
      // 사용품목(실적)
      setColumns([
        {
          field: "viewer",
          headerName: "상세",
          width: 55,
          type: "actions",
          disableClickEventBubbling: true,
          getActions: (params) => [
            <GridActionsCellItem
              icon={<AssignmentIcon color={"primary"} />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                DetailClick(params);
              }}
              label="Viewer"
            />,
          ],
          headerAlign: "center",
          align: "center",
        },
        { field: "id", headerName: "id", width: 0, headerAlign: "center", align: "center" },
        { field: "gijun_date", headerName: "기준일자", width: 150, headerAlign: "center", align: "center" },
        { field: "gijun_month", headerName: "기준년월", width: 150, headerAlign: "center", align: "center" },
        { field: "item_name", headerName: "품목명", width: 150, headerAlign: "center", align: "left" },
        { field: "item_spec", headerName: "규격", width: 200, headerAlign: "center", align: "left" },
        {
          field: "sum_produce_input_plan_count",
          headerName: "사용계획수량",
          width: 120,
          headerAlign: "center",
          align: "right",
        },
        {
          field: "sum_produce_input_count",
          headerName: "사용수량",
          width: 100,
          headerAlign: "center",
          align: "right",
        },
      ]);
    }

    let nextKeyword = null;
    if (tabID === "") {
      setTabID("1");
      return;
    }

    if (tabID === "1") {
      nextKeyword = {
        ...keyword,
        start_date: Moment().format("YYYY-MM-01"),
        end_date: appStore.YYYY_MM_DD(),
      };
    } else if (tabID === "2") {
      nextKeyword = {
        ...keyword,
        start_date: Moment().format("YYYY-01-01"),
        end_date: appStore.YYYY_MM_DD(),
      };
    }
    setKeyword(nextKeyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabID, keyword.status2]);

  // 설비 선택 / 기간 / 기준 바뀔 때마다 machine_type 세팅 + 조회
  useEffect(() => {
    if (machineInfo.length > 0) {
      const selected = machineInfo.find(
        (m) => String(m.machine_id) === String(keyword.machine_id)
      );
      let nextKeyword = {};
      if (selected) {
        nextKeyword = {
          ...keyword,
          machine_type: selected.machine_type,
        };
      } else {
        nextKeyword = {
          ...keyword,
          machine_type: "",
        };
      }
      setKeyword(nextKeyword);
      handleView();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword.start_date, keyword.end_date, keyword.machine_id, keyword.status2]);

  // 메뉴 권한 세팅 후 초기 조회
  useEffect(() => {
    if (String(MenuID) !== String(0) && MenuID != null) {
      handleInitSelect();
      handleView();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MenuID]);

  // 메뉴 권한 체크
  useEffect(() => {
    const accessList = JSON.parse(localStorage.getItem("nav"));

    if (
      Array.isArray(accessList) &&
      accessList.filter(
        (item) =>
          String(item.menu_url) ===
          String(window.location.pathname).split("/").slice(0, 3).join("/")
      ).length > 0
    ) {
      const cur = accessList.find(
        (item) =>
          String(item.menu_url) ===
          String(window.location.pathname).split("/").slice(0, 3).join("/")
      );
      setMenuID(cur.menu_id);
      setMenuName(cur.menu_name);
      setMenuUpdateExistYN(cur.menu_update_exist_yn);
      setMenuDeleteExistYN(cur.menu_delete_exist_yn);
      setMenuUpdateYN(cur.menu_update_yn);
      setMenuDeleteYN(cur.menu_delete_yn);
    } else {
      Swal.fire({
        title: '<p style="color:red">접근 권한 오류</p>',
        text: "화면에 접근 권한이 없습니다.",
        confirmButtonText: "확인",
        confirmButtonColor: "#7066e0",
        timer: 5000,
        timerProgressBar: true,
      }).then((value) => {
        return navigate(-1);
      });
    }
  }, [navigate]);

  // 설비/기준 select 초기화
  const handleInitSelect = () => {
    let type_list = "";
    axios
    .get("/api/SelectCommon/MachineList")
    .then((response) => {
      const optionArray = response.data.map((item) => ({
        value: item.machine_id,
        label: item.machine_name,
      }));
      optionArray.unshift({ value: "", label: "전체" });
      setMachineOption([...new Set(optionArray.map(JSON.stringify))].map(JSON.parse));

      const full_array = [];
      response.data.forEach((item) => {
        if (String(item.machine_type) === "1") {
          setFauncYN("Y");
        }
        full_array.push({
          machine_id: item.machine_id,
          machine_type: item.machine_type,
          machine_name: item.machine_name,
        });
        if (type_list === "") {
          type_list = String(item.machine_type);
        } else {
          type_list = String(type_list) + "," + String(item.machine_type);
        }
      });
      setMachineInfo(full_array);

      // 기준
      let array2 = [
        { value: 1, label: "생산수량" },
        { value: 2, label: "프로젝트" },
        { value: 3, label: "생산품목(실적)" },
      ];
      if (!(type_list ?? "").includes("1")) {
        array2 = [{ value: 1, label: "생산수량" }];
      }
      setStatus2Option(array2);
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const handleInit = () => {
    setTabID("");
  };

  const nz = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

  const fmtMinToHHMM = (v) => {
    const total = Math.round(nz(v));
    const h = Math.floor(total / 60);
    const m = total % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const toRoundedPercentStr = (value) => {
    if (value === null || value === undefined) return "";
    const num =
      typeof value === "number" ? value : Number(String(value).replace(/,/g, ""));
    if (!Number.isFinite(num)) return "";
    return String(Math.round(num)) + "%";
  };

  // ★ 기준일 / 기준월
  const CUTOFF_DATE = "2025-11-24"; // 이 날짜 '이전'까지는 정수, '이상'부터는 소수점 2자리
  const CUTOFF_MONTH = "2025-11";   // 월별 기준 (2025-11 이상이면 소수점 2자리)

  // 공통: 소수점 N자리 퍼센트 문자열
  const toFixedPercentStr = (value, digits = 2) => {
    if (value === null || value === undefined) return "";
    const num =
      typeof value === "number" ? value : Number(String(value).replace(/,/g, ""));
    if (!Number.isFinite(num)) return "";
    return num.toFixed(digits) + "%";
  };

  // ★ 일별: 기준일자를 보고 정수/소수점2자리 선택
  const toPercentByDate = (value, dateStr) => {
    if (!dateStr) return toRoundedPercentStr(value);
    // "YYYY-MM-DD" 형식이라 문자열 비교로도 안전
    if (dateStr >= CUTOFF_DATE) {
      // 2025-11-24 이상 → 소수점 2자리
      return toFixedPercentStr(value, 2);
    }
    // 그 이전 → 정수
    return toRoundedPercentStr(value);
  };

  // ★ 월별: 기준년월을 보고 정수/소수점2자리 선택
  const toPercentByMonth = (value, monthStr) => {
    if (!monthStr) return toRoundedPercentStr(value);
    // "YYYY-MM" 형식이라 문자열 비교로도 안전
    if (monthStr >= CUTOFF_MONTH) {
      // 2025-11 이상 → 소수점 2자리
      return toFixedPercentStr(value, 2);
    }
    return toRoundedPercentStr(value);
  };


  const toDateStr = (d) => {
    if (!d) return "";
    const dt = d instanceof Date ? d : new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const toMonthStr = (dOrYYYYMM) => {
    if (!dOrYYYYMM) return "";
    if (typeof dOrYYYYMM === "string" && /^\d{4}-\d{2}$/.test(dOrYYYYMM)) return dOrYYYYMM;
    const dt = dOrYYYYMM instanceof Date ? dOrYYYYMM : new Date(dOrYYYYMM);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
  };

  // ★ 수정 후 (반올림 제거 + KPI 공식 동일하게)
  const calcRunPercent = (runMin, machineCount, kpiRunTime) => {
    if(String(machineCount) == '0'){
      machineCount = '1'
    }
    const v = nz(runMin);           // 총 가동시간(분)
    const mc = nz(machineCount);    // 설비 수
    const rt = nz(kpiRunTime) || 8; // 기준 시간(시간, 없으면 8)
    
    if (!v || !mc || !rt) return 0;

    // 1) 분 → 시간으로 변환하면서 반올림 (SQL: ROUND(SUM(value_min)/60))
    const usedHours = Math.round(v / 60);

    // 2) 기준시간 (설비수 × kpi_run_time)
    const baseHours = mc * rt;
    if (!baseHours) return 0;

    // 3) 비율
    return (usedHours / baseHours) * 100;
  };

  // ★ 불량율 계산: (불량수량 / (양품수량 + 불량수량)) * 100
  const calcErrorPercent = (okQty, ngQty) => {
    const ok = nz(okQty);
    const ng = nz(ngQty);
    const total = ok + ng;          // 실적수량 = 양품 + 불량
    if (!total) return 0;
    return (ng / total) * 100;
  };

  // 범용 피벗(그룹 합계)
  function pivotSum(rows, groupKeys, sumKeys) {
    const map = new Map();
    for (const r of rows || []) {
      const keyObj = {};
      for (const k of groupKeys) {
        if (k === "gijun_date")
          keyObj[k] = r.gijun_date ? toDateStr(r.gijun_date) : "";
        else if (k === "gijun_month")
          keyObj[k] = r.gijun_month || (r.gijun_date ? toMonthStr(r.gijun_date) : "");
        else keyObj[k] = r[k] ?? "";
      }
      const key = JSON.stringify(keyObj);
      if (!map.has(key)) {
        const init = { ...keyObj };
        for (const s of sumKeys) init[s] = 0;
        map.set(key, init);
      }
      const acc = map.get(key);
      for (const s of sumKeys) acc[s] += nz(r[s]);
    }
    const order = ["gijun_month", "gijun_date", "project_name", "item_name", "item_spec"];
    return Array.from(map.values()).sort((a, b) => {
      for (const k of order) {
        if ((a[k] ?? "") !== (b[k] ?? ""))
          return String(a[k] ?? "").localeCompare(String(b[k] ?? ""));
      }
      return 0;
    });
  }

  // 그룹별 설비 개수(중복 machine_id 제거)
  function buildMachineCountMap(rows, groupKeys) {
    const map = new Map(); // key -> Set(machine_id)
    for (const r of rows || []) {
      const keyObj = {};
      for (const k of groupKeys) {
        if (k === "gijun_date")
          keyObj[k] = r.gijun_date ? toDateStr(r.gijun_date) : "";
        else if (k === "gijun_month")
          keyObj[k] = r.gijun_month || (r.gijun_date ? toMonthStr(r.gijun_date) : "");
        else keyObj[k] = r[k] ?? "";
      }
      const key = JSON.stringify(keyObj);
      if (!map.has(key)) map.set(key, new Set());
      const set = map.get(key);
      const mid = r.machine_id != null ? String(r.machine_id) : "";
      if (mid) set.add(mid);
    }
    const countMap = new Map();
    for (const [key, set] of map.entries()) {
      countMap.set(key, set.size || 0);
    }
    return countMap;
  }

  // 조회
  const handleView = () => {
    if (
      keyword.start_date.length === 10 &&
      keyword.end_date.length === 10 &&
      keyword.start_date >= "2025-01-01" &&
      keyword.end_date >= "2025-01-01" &&
      keyword.start_date <= "2049-12-31" &&
      keyword.end_date <= "2049-12-31"
    ) {
      setGraphData([]);
      if (tabID === "1") {
        setColumnVisibilityModel({
          id: false,
          gijun_month: false,
          gijun_date: true,
        });
      } else if (tabID === "2") {
        setColumnVisibilityModel({
          id: false,
          gijun_month: true,
          gijun_date: false,
        });
      }

      if (appStore.loading) return;
      appStore.setLoading(true);

      axios
        .get(
          "/api/p/MachineProduceStatistics/List",
          {
            params: {
              start_date: keyword.start_date,
              end_date: keyword.end_date,
              status: tabID,
              status2: keyword.status2,
              machine_id: keyword.machine_id,
              machine_type: keyword.machine_type,
            },
          },
          { withCredentials: true }
        )
        .then((response) => {
          const fmt = (v) => Number(v ?? 0).toLocaleString("ko-KR");
          setOriginRows(response.data);

          const prodReports = buildProductionReports(response.data);
          
          if (tabID === "1" && keyword.status2 === 1) {
            setGraphTitle("일별 생산수량");
            setRows(
              (prodReports.daily_qty || []).map((item, idx) => ({
                id: String(idx),
                gijun_date: item.gijun_date,
                sum_produce_count: fmt(item.produce_count),
                sum_produce_complete_count: fmt(item.produce_complete_count),
                sum_produce_error_count: fmt(item.produce_error_count),
                sum_run_min_str: fmtMinToHHMM(item.run_min),
                percent_run_min_str: toPercentByDate(item.run_percent, item.gijun_date),
                produce_error_percent: toPercentByDate(
                  item.produce_error_percent,
                  item.gijun_date
                ),
              }))
            );

            setGraphData(
              (prodReports.daily_qty || []).map((r) => ({
                name: r.gijun_date,
                생산수량: Number(r.produce_count) || 0,
                양품수량: Number(r.produce_complete_count) || 0,
                불량수량: Number(r.produce_error_count) || 0,
              }))
            );
          } else if (tabID === "2" && keyword.status2 === 1) {
            setGraphTitle("월별 생산수량");
            setRows(
              (prodReports.monthly_qty || []).map((item, idx) => ({
                id: String(idx),
                gijun_month: item.gijun_month,
                sum_produce_count: fmt(item.produce_count),
                sum_produce_complete_count: fmt(item.produce_complete_count),
                sum_produce_error_count: fmt(item.produce_error_count),
                sum_run_min_str: fmtMinToHHMM(item.run_min),
                percent_run_min_str: '',
                produce_error_percent: '',
              }))
            );

            setGraphData(
              (prodReports.monthly_qty || []).map((r) => ({
                name: r.gijun_month,
                생산수량: Number(r.produce_count) || 0,
                양품수량: Number(r.produce_complete_count) || 0,
                불량수량: Number(r.produce_error_count) || 0,
              }))
            );
          } else if (tabID === "1" && keyword.status2 === 2) {
            setGraphTitle("일별 프로젝트 생산수량");
            setRows(
              (prodReports.daily_project || []).map((item, idx) => ({
                id: String(idx),
                gijun_date: item.gijun_date,
                project_name: item.project_name,
                sum_produce_count: fmt(item.produce_count),
                sum_produce_complete_count: fmt(item.produce_complete_count),
                sum_produce_error_count: fmt(item.produce_error_count),
                sum_run_min_str: fmtMinToHHMM(item.run_min),
                percent_run_min_str: toRoundedPercentStr(item.run_percent),
                produce_error_percent: toRoundedPercentStr(item.produce_error_percent),
              }))
            );

            const N = (v) => Number(v ?? 0);
            setGraphData(
              (prodReports.daily_project || []).map((r) => ({
                xlabel: `${r.gijun_date} | ${r.project_name || "(미지정)"}`,
                생산수량: N(r.produce_count),
                양품수량: N(r.produce_complete_count),
                불량수량: N(r.produce_error_count),
                gijun_date: r.gijun_date,
                project_name: r.project_name,
              }))
            );
          } else if (tabID === "2" && keyword.status2 === 2) {
            setGraphTitle("월별 프로젝트 생산수량");
            setRows(
              (prodReports.monthly_project || []).map((item, idx) => ({
                id: String(idx),
                gijun_month: item.gijun_month,
                project_name: item.project_name,
                sum_produce_count: fmt(item.produce_count),
                sum_produce_complete_count: fmt(item.produce_complete_count),
                sum_produce_error_count: fmt(item.produce_error_count),
                sum_run_min_str: fmtMinToHHMM(item.run_min),
                percent_run_min_str: toRoundedPercentStr(item.run_percent),
                produce_error_percent: toRoundedPercentStr(item.produce_error_percent),
              }))
            );

            const N = (v) => Number(v ?? 0);
            setGraphData(
              (prodReports.monthly_project || []).map((r) => ({
                xlabel: `${r.gijun_month} | ${r.project_name || "(미지정)"}`,
                생산수량: N(r.produce_count),
                양품수량: N(r.produce_complete_count),
                불량수량: N(r.produce_error_count),
                gijun_month: r.gijun_month,
                project_name: r.project_name,
              }))
            );
          } else if (tabID === "1" && keyword.status2 === 3) {
            setGraphTitle("일별 생산품목(실적) 생산수량");
            setRows(
              (prodReports.daily_item || []).map((item, idx) => ({
                id: String(idx),
                gijun_date: item.gijun_date,
                item_name: item.item_name,
                item_spec: item.item_spec,
                sum_produce_count: fmt(item.produce_count),
                sum_produce_complete_count: fmt(item.produce_complete_count),
                sum_produce_error_count: fmt(item.produce_error_count),
                sum_run_min_str: fmtMinToHHMM(item.run_min),
                percent_run_min_str: toRoundedPercentStr(item.run_percent),
                produce_error_percent: toRoundedPercentStr(item.produce_error_percent),
              }))
            );

            const N = (v) => Number(v ?? 0);
            setGraphData(
              (prodReports.daily_item || []).map((r) => ({
                xlabel: `${r.gijun_date} | ${r.item_name}`,
                생산수량: N(r.produce_count),
                양품수량: N(r.produce_complete_count),
                불량수량: N(r.produce_error_count),
                gijun_date: r.gijun_date,
                item_name: r.item_name,
              }))
            );
          } else if (tabID === "2" && keyword.status2 === 3) {
            setGraphTitle("월별 생산품목(실적) 생산수량");
            setRows(
              (prodReports.monthly_item || []).map((item, idx) => ({
                id: String(idx),
                gijun_month: item.gijun_month,
                item_name: item.item_name,
                item_spec: item.item_spec,
                sum_produce_count: fmt(item.produce_count),
                sum_produce_complete_count: fmt(item.produce_complete_count),
                sum_produce_error_count: fmt(item.produce_error_count),
                sum_run_min_str: fmtMinToHHMM(item.run_min),
                percent_run_min_str: toRoundedPercentStr(item.run_percent),
                produce_error_percent: toRoundedPercentStr(item.produce_error_percent),
              }))
            );

            const N = (v) => Number(v ?? 0);
            setGraphData(
              (prodReports.monthly_item || []).map((r) => ({
                xlabel: `${r.gijun_month} | ${r.item_name}`,
                생산수량: N(r.produce_count),
                양품수량: N(r.produce_complete_count),
                불량수량: N(r.produce_error_count),
                gijun_month: r.gijun_month,
                item_name: r.item_name,
              }))
            );
          }
        })
        .catch((error) => {
          appStore.capture();
        })
        .finally(() => {
          appStore.setLoading(false);
        });
    }
  };

  function toDetail(base, qty = {}, usage = {}) {
    return {
      gijun_month:
        base.gijun_month || (base.gijun_date ? toMonthStr(base.gijun_date) : ""),
      gijun_date: base.gijun_date || "",
      project_name: base.project_name || "",
      item_name: base.item_name || "",
      item_spec: base.item_spec || "",
      produce_count: nz(qty.produce_count),
      produce_complete_count: nz(qty.produce_complete_count),
      produce_error_count: nz(qty.produce_error_count),
      use_plan_qty: nz(usage.use_plan_qty),
      use_qty: nz(usage.use_qty),
    };
  }

    // 생산 리포트 빌더
  // - 가동시간(run_min)은 "날짜 + 설비" 기준으로만 집계해서 가동률 계산
  // - 생산수량/양품/불량은 프로젝트/품목 기준으로 자유롭게 집계
  function buildProductionReports(prodRows) {
    // 1) 기본 정규화 + 쿼리에서 온 machine_count_std 포함
    const norm = (prodRows || []).map((r) => ({
      ...r,
      gijun_date: r.gijun_date ? toDateStr(r.gijun_date) : "",
      gijun_month: r.gijun_month || (r.gijun_date ? toMonthStr(r.gijun_date) : ""),
      project_name: r.project_name || "",
      item_name: r.item_name || "",
      item_spec: r.item_spec || "",
      produce_count: nz(r.produce_count),
      produce_complete_count: nz(r.produce_complete_count),
      produce_error_count: nz(r.produce_error_count),
      run_min: nz(r.run_min),
      run_percent: nz(r.run_percent),
      produce_error_percent: nz(r.produce_error_percent),
      machine_id: r.machine_id,
      // ★ 쿼리에서 넘어온 기준 설비 대수
      machine_count_std: nz(r.machine_count_std),
      // ★ 쿼리에서 내려준 KPI 가동시간(시간 단위)
      kpi_run_time: nz(r.kpi_run_time),
    }));

    const hasItemName = (v) => !!String(v ?? "").trim();
    // ★ run_min은 따로 처리, 여기서는 수량만 합산
    const SUM_QTY = ["produce_count", "produce_complete_count", "produce_error_count"];

    // 2) "날짜 + 설비" 기준으로 가동시간 추출
    //    - project_name 이 빈 행(집계행)을 우선 사용
    const dailyMachineRun = new Map(); // key: `${date}__${machine_id}` -> run_min
    for (const r of norm) {
      const date = r.gijun_date;
      const mid = r.machine_id != null ? String(r.machine_id) : "";
      if (!date || !mid) continue;

      const key = `${date}__${mid}`;
      const value = nz(r.run_min);
      const hasProject = (r.project_name || "").trim() !== "";

      if (!hasProject) {
        // 집계행은 무조건 우선권 (덮어쓰기)
        dailyMachineRun.set(key, value);
      } else if (!dailyMachineRun.has(key)) {
        // 집계행이 없을 때만 첫 프로젝트 행을 fallback 으로 사용
        dailyMachineRun.set(key, value);
      }
    }

    // 3) 일별 run_min 합계
    const dailyRunSum = new Map(); // date -> run_min
    for (const [key, v] of dailyMachineRun.entries()) {
      const [date] = key.split("__");
      dailyRunSum.set(date, (dailyRunSum.get(date) || 0) + nz(v));
    }

    // 4) 월별 run_min 합계 (일별 합계를 다시 합산)
    const monthlyRunSum = new Map(); // "YYYY-MM" -> run_min
    for (const [date, v] of dailyRunSum.entries()) {
      const month = toMonthStr(date);
      monthlyRunSum.set(month, (monthlyRunSum.get(month) || 0) + nz(v));
    }

    // 5) 기준 설비 수 map (일/월)
    //    - company_id=3 & 2025-09-17 이전은 3대, 그 이후/다른 회사는 쿼리에서 이미 처리됨
    const stdCountByDate = new Map();  // gijun_date -> machine_count_std
    const stdCountByMonth = new Map(); // gijun_month -> machine_count_std
    for (const r of norm) {
      const std = nz(r.machine_count_std);
      if (r.gijun_date) {
        const d = r.gijun_date;
        if (!stdCountByDate.has(d) || std > stdCountByDate.get(d)) {
          stdCountByDate.set(d, std);
        }
      }
      if (r.gijun_month) {
        const m = r.gijun_month;
        if (!stdCountByMonth.has(m) || std > stdCountByMonth.get(m)) {
          stdCountByMonth.set(m, std);
        }
      }
    }

    // 5-1) 날짜/월별 KPI 가동시간 map
    const runTimeByDate = new Map();   // gijun_date  -> kpi_run_time(시간)
    const runTimeByMonth = new Map();  // gijun_month -> kpi_run_time(시간)
    for (const r of norm) {
      const rt = nz(r.kpi_run_time);
      if (r.gijun_date && !runTimeByDate.has(r.gijun_date)) {
        runTimeByDate.set(r.gijun_date, rt);
      }
      if (r.gijun_month && !runTimeByMonth.has(r.gijun_month)) {
        runTimeByMonth.set(r.gijun_month, rt);
      }
    }

    // ------------------------------
    // [일별 - 생산수량] (그리드/그래프 기준 1번)
    // ------------------------------
    const daily_qty = pivotSum(norm, ["gijun_date"], SUM_QTY).map((x) => {
      const date = x.gijun_date;
      const mcStd = stdCountByDate.get(date) || 0;         // ★ 기준 설비 수
      const run_min = dailyRunSum.get(date) || 0;          // 해당 일 전체 가동시간(분)
      const kpiRunTime = runTimeByDate.get(date);          // ✅ KPI 가동시간(시간)
      const run_percent = calcRunPercent(run_min, mcStd, kpiRunTime);  // ★ 여기서 가동율 계산

      const produce_error_percent = calcErrorPercent(
        x.produce_complete_count,
        x.produce_error_count
      );

      return {
        detail: toDetail({ gijun_date: date }, x),
        gijun_date: date,
        machine_count: mcStd,
        produce_count: x.produce_count,
        produce_complete_count: x.produce_complete_count,
        produce_error_count: x.produce_error_count,
        run_min,
        run_percent,
        produce_error_percent,
      };
    });

    // ------------------------------
    // [일별 - 프로젝트]
    // ------------------------------
    const daily_project = pivotSum(
      norm,
      ["gijun_date", "project_name"],
      SUM_QTY
    ).map((x) => {
      const date = x.gijun_date;
      const mcStd = stdCountByDate.get(date) || 0;

      const produce_error_percent =
        x.produce_error_count && x.produce_count
          ? (x.produce_error_count / x.produce_count) * 100
          : 0;

      return {
        detail: toDetail(
          { gijun_date: x.gijun_date, project_name: x.project_name },
          x
        ),
        gijun_date: x.gijun_date,
        project_name: x.project_name,
        machine_count: mcStd,
        produce_count: x.produce_count,
        produce_complete_count: x.produce_complete_count,
        produce_error_count: x.produce_error_count,
        // 프로젝트 단위에서는 가동시간/가동률 사용 안 함 (0 처리)
        run_min: 0,
        run_percent: 0,
        produce_error_percent,
      };
    });

    // ------------------------------
    // [일별 - 생산품목(실적)]
    // ------------------------------
    const normHasItemDaily = norm.filter((r) => hasItemName(r.item_name));
    const daily_item = pivotSum(
      normHasItemDaily,
      ["gijun_date", "item_name", "item_spec"],
      SUM_QTY
    ).map((x) => {
      const date = x.gijun_date;
      const mcStd = stdCountByDate.get(date) || 0;

      const produce_error_percent =
        x.produce_error_count && x.produce_count
          ? (x.produce_error_count / x.produce_count) * 100
          : 0;

      return {
        detail: toDetail(
          { gijun_date: x.gijun_date, item_name: x.item_name, item_spec: x.item_spec },
          x
        ),
        gijun_date: x.gijun_date,
        item_name: x.item_name,
        item_spec: x.item_spec,
        machine_count: mcStd,
        produce_count: x.produce_count,
        produce_complete_count: x.produce_complete_count,
        produce_error_count: x.produce_error_count,
        run_min: 0,
        run_percent: 0,
        produce_error_percent,
      };
    });

    // ------------------------------
    // [월별 - 생산수량] (그리드/그래프 기준 2번)
    // ------------------------------
    const monthly_qty = pivotSum(norm, ["gijun_month"], SUM_QTY).map((x) => {
      const month = x.gijun_month;
      const mcStd = stdCountByMonth.get(month) || 0;
      const run_min = monthlyRunSum.get(month) || 0;
      const kpiRunTime = runTimeByMonth.get(month);        // ✅ 월별 KPI 가동시간
      const run_percent = calcRunPercent(run_min, mcStd, kpiRunTime);

      const produce_error_percent = calcErrorPercent(
        x.produce_complete_count,
        x.produce_error_count
      );

      return {
        detail: toDetail({ gijun_month: month }, x),
        gijun_month: month,
        machine_count: mcStd,
        produce_count: x.produce_count,
        produce_complete_count: x.produce_complete_count,
        produce_error_count: x.produce_error_count,
        run_min,
        run_percent,
        produce_error_percent,
      };
    });

    // ------------------------------
    // [월별 - 프로젝트]
    // ------------------------------
    const monthly_project = pivotSum(
      norm,
      ["gijun_month", "project_name"],
      SUM_QTY
    ).map((x) => {
      const month = x.gijun_month;
      const mcStd = stdCountByMonth.get(month) || 0;

      const produce_error_percent =
        x.produce_error_count && x.produce_count
          ? (x.produce_error_count / x.produce_count) * 100
          : 0;

      return {
        detail: toDetail(
          { gijun_month: x.gijun_month, project_name: x.project_name },
          x
        ),
        gijun_month: x.gijun_month,
        project_name: x.project_name,
        machine_count: mcStd,
        produce_count: x.produce_count,
        produce_complete_count: x.produce_complete_count,
        produce_error_count: x.produce_error_count,
        run_min: 0,
        run_percent: 0,
        produce_error_percent,
      };
    });

    // ------------------------------
    // [월별 - 생산품목(실적)]
    // ------------------------------
    const normHasItemMonthly = norm.filter((r) => hasItemName(r.item_name));
    const monthly_item = pivotSum(
      normHasItemMonthly,
      ["gijun_month", "item_name", "item_spec"],
      SUM_QTY
    ).map((x) => {
      const month = x.gijun_month;
      const mcStd = stdCountByMonth.get(month) || 0;

      const produce_error_percent =
        x.produce_error_count && x.produce_count
          ? (x.produce_error_count / x.produce_count) * 100
          : 0;

      return {
        detail: toDetail(
          { gijun_month: x.gijun_month, item_name: x.item_name, item_spec: x.item_spec },
          x
        ),
        gijun_month: x.gijun_month,
        item_name: x.item_name,
        item_spec: x.item_spec,
        machine_count: mcStd,
        produce_count: x.produce_count,
        produce_complete_count: x.produce_complete_count,
        produce_error_count: x.produce_error_count,
        run_min: 0,
        run_percent: 0,
        produce_error_percent,
      };
    });

    return { daily_qty, daily_project, daily_item, monthly_qty, monthly_project, monthly_item };
  }


  // 날짜 변경 핸들러 (기존 그대로)
  const onDateChange = (e) => {
    let dateType = "N";
    let tempStartDate = "";
    let tempEndDate = "";

    if (e.target.name === "start_date") {
      if (Moment(e.target.value).diff(Moment(keyword.end_date), "days") > 0) {
        dateType = "U";
      }
    } else if (e.target.name === "end_date") {
      if (Moment(e.target.value).diff(Moment(keyword.start_date), "days") < 0) {
        dateType = "U";
      }
    } else {
      if (
        (e.target.name === "start_date" &&
          Moment(e.target.value) > Moment(keyword.end_date)) ||
        (e.target.name === "end_date" &&
          Moment(keyword.start_date) > Moment(e.target.value))
      ) {
        dateType = "U";
      }
    }

    if (tabID === "1") {
      // 일별
      if (e.target.name === "start_date") {
        if (Moment(e.target.value).diff(Moment(keyword.end_date), "days") < -31) {
          dateType = "D";
          tempStartDate = e.target.value;
          tempEndDate = Moment(e.target.value)
            .add("1", "M")
            .add("-1", "d")
            .format("YYYY-MM-DD");
        }
      } else if (e.target.name === "end_date") {
        if (Moment(e.target.value).diff(Moment(keyword.start_date), "days") > 31) {
          dateType = "D";
          tempStartDate = Moment(e.target.value)
            .add("-1", "M")
            .add("1", "d")
            .format("YYYY-MM-DD");
          tempEndDate = e.target.value;
        }
      }
    } else if (tabID === "2") {
      // 월별
      if (e.target.name === "start_date") {
        if (Moment(e.target.value).diff(Moment(keyword.end_date), "month") < -12) {
          dateType = "M";
          tempStartDate = e.target.value;
          tempEndDate = Moment(e.target.value).add("1", "Y").format("YYYY-MM-DD");
        }
      } else if (e.target.name === "end_date") {
        if (Moment(e.target.value).diff(Moment(keyword.start_date), "month") > 12) {
          dateType = "M";
          tempStartDate = Moment(e.target.value)
            .add("-1", "Y")
            .format("YYYY-MM-DD");
          tempEndDate = e.target.value;
        }
      }
    }

    if (dateType === "U") {
      const { name, value } = e.target;
      let startDate = "";
      let endDate = "";
      let nextKeyword = {
        ...keyword,
        start_date: value,
        end_date: value,
      };

      if (e.target.name === "start_date") {
        if (
          ((new Date()).toISOString().substr(0, 10) < value) ||
          Moment(e.target.value) > Moment(keyword.end_date)
        ) {
          if (tabID === "1") {
            startDate = (new Date()).toISOString().substr(0, 8) + "01";
            endDate = (new Date()).toISOString().substr(0, 10);
          } else if (tabID === "2") {
            startDate = (new Date()).toISOString().substr(0, 5) + "01-01";
            endDate = (new Date()).toISOString().substr(0, 10);
          }
        } else if ((new Date()).toISOString().substr(0, 10) >= value) {
          if (tabID === "1") {
            startDate = value;
            if (
              Moment(value)
                .add("1", "M")
                .add("-1", "d")
                .format("YYYY-MM-DD") <=
              (new Date()).toISOString().substr(0, 10)
            ) {
              endDate = Moment(value)
                .add("1", "M")
                .add("-1", "d")
                .format("YYYY-MM-DD");
            } else {
              endDate = (new Date()).toISOString().substr(0, 10);
            }
          } else if (tabID === "2") {
            if (
              Moment(value).format("YYYY-12-31") <=
              (new Date()).toISOString().substr(0, 10)
            ) {
              endDate = Moment(value).format("YYYY-12-31");
            } else {
              endDate = (new Date()).toISOString().substr(0, 10);
            }
          }
        }
      } else if (e.target.name === "end_date") {
        if (
          ((new Date()).toISOString().substr(0, 10) < value) ||
          Moment(keyword.start_date) > Moment(e.target.value)
        ) {
          if (tabID === "1") {
            startDate = (new Date()).toISOString().substr(0, 8) + "01";
            endDate = (new Date()).toISOString().substr(0, 10);
          } else if (tabID === "2") {
            startDate = (new Date()).toISOString().substr(0, 5) + "01-01";
            endDate = (new Date()).toISOString().substr(0, 10);
          }
        } else if ((new Date()).toISOString().substr(0, 10) >= value) {
          if (tabID === "1") {
            startDate = Moment(value).format("YYYY-MM-01");
          } else if (tabID === "2") {
            startDate = Moment(value).format("YYYY-01-01");
          }
          endDate = value;
        }
      }

      nextKeyword = {
        ...keyword,
        start_date: startDate,
        end_date: endDate,
      };

      setKeyword(nextKeyword);
    } else if (dateType === "N") {
      const { name, value } = e.target;
      const nextKeyword = {
        ...keyword,
        [name]: value,
      };
      setKeyword(nextKeyword);
    } else if (dateType === "D" || dateType === "M") {
      const nextKeyword = {
        ...keyword,
        start_date: tempStartDate,
        end_date: tempEndDate,
      };
      setKeyword(nextKeyword);
    }
  };

  const onSelectChange = (type, value) => {
    const nextKeyword = {
      ...keyword,
      [type]: value,
    };
    setKeyword(nextKeyword);
  };

  const DetailClick = (object) => {
    setDetailModalOpen(true);
    if (String(tabID) === "1") {
      setSelectDataID(object.row.gijun_date);
    } else {
      setSelectDataID(object.row.gijun_month);
    }
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  return (
    <div
      style={{
        width: "100%",
        display: String(MenuID) === String(0) ? "hidden" : "block",
      }}
    >
      <div className="menubox" style={{ height: "185px", boxShadow: "none" }}>
        <div className="menu-action" style={{ height: "55px" }}>
          <div className="menu-title">{MenuName}</div>
          <div className="menu-button">
            <Button
              onClick={handleInit}
              className="btn-p"
              sx={{
                m: 1,
                fontSize: 15,
                color: "white",
                borderColor: "black",
                backgroundColor: "black",
                ":hover": {
                  boxShadow: "2px 2px 2px black",
                  backgroundColor: "black",
                  borderColor: "black",
                },
              }}
              variant="outlined"
            >
              초기화
            </Button>
            <Button
              onClick={handleView}
              className="btn-p"
              sx={{
                m: 1,
                fontSize: 15,
                color: "white",
                borderColor: "#3D63AE",
                backgroundColor: "#3D63AE",
                ":hover": {
                  boxShadow: "2px 2px 2px #3D63AE",
                  backgroundColor: "#3D63AE",
                  borderColor: "#3D63AE",
                },
              }}
              variant="outlined"
            >
              조회
            </Button>
          </div>
        </div>
        <TabContext value={tabID}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleTabID} style={{ paddingLeft: "20px" }}>
              <Tab key={1} label={"일별"} value={"1"} />
              <Tab key={2} label={"월별"} value={"2"} />
            </TabList>
          </Box>
        </TabContext>
        <div className="menu-keyword" style={{ paddingTop: "5px" }}>
          <div className="menu-keyword-sub">
            <div
              className="menu-keyword-sub-title"
              style={{ width: "80px", paddingTop: "7px", fontWeight: "bold" }}
            >
              설비
            </div>
            <div className="menu-keyword-sub-keyword">
              <Select
                className="menu-keyword-sub-keyword-select"
                placeholder="설비"
                onChange={(e) => onSelectChange("machine_id", e.value)}
                value={machineOption.filter((option) => option.value === keyword.machine_id)}
                options={machineOption}
                noOptionsMessage={() => "조회되는 항목 없음"}
              />
            </div>
          </div>
          <div className="menu-keyword-sub">
            <div
              className="menu-keyword-sub-title"
              style={{ width: "100px", fontWeight: "bold" }}
            >
              조회기간
            </div>
            <div
              className="menu-keyword-sub-keyword"
              style={{ maxWidth: "200px" }}
            >
              <input
                type="date"
                value={keyword.start_date}
                name="start_date"
                onChange={(e) => onDateChange(e)}
                autoComplete="off"
              />
            </div>
            <div
              className="menu-keyword-sub-title"
              style={{ textAlign: "center", width: "50px" }}
            >
              ~
            </div>
            <div
              className="menu-keyword-sub-keyword"
              style={{ maxWidth: "200px" }}
            >
              <input
                type="date"
                value={keyword.end_date}
                name="end_date"
                onChange={(e) => onDateChange(e)}
                autoComplete="off"
              />
            </div>
          </div>
          {(tabID === "1" || tabID === "2") && (
            <div className="menu-keyword-sub">
              <div
                className="menu-keyword-sub-title"
                style={{ width: "80px", paddingTop: "7px", fontWeight: "bold" }}
              >
                기준
              </div>
              <div className="menu-keyword-sub-keyword">
                <Select
                  className="menu-keyword-sub-keyword-select"
                  placeholder="기준"
                  onChange={(e) => onSelectChange("status2", e.value)}
                  value={status2Option.filter((option) => option.value === keyword.status2)}
                  options={status2Option}
                  noOptionsMessage={() => "조회되는 항목 없음"}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="grid" style={{ top: "187px" }}>
        <div style={{ float: "left", width: gridWidth }}>
          <div
            className="grid_sub"
            style={{
              width: "100%",
              height: "calc(100vh - 287px)",
              fontSize: "17px",
            }}
          >
            <DataGrid
              className="grid_main"
              rows={rows}
              columns={columns}
              slots={{
                noRowsOverlay: GridNoRow,
              }}
              columnVisibilityModel={columnVisibilityModel}
              AlternatingRowBackground="LavenderBlush"
              rowsPerPageOptions={[20, 50, 100]}
            />
            {isDetailModalOpen && (
              <MachineProductionStatisticsModal
                onClose={() => {
                  setDetailModalOpen(false);
                }}
                title={modalTitle}
                originRows={originRows}
                selectDataID={selectDataID}
                keyword={keyword}
                tabID={tabID}
              />
            )}
          </div>
        </div>
        <div
          style={{
            float: "right",
            width: "calc(100% - " + gridWidth + ")",
            paddingRight: "20px",
          }}
        >
          <h3
            style={{
              margin: "0px",
              textAlign: "center",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: "24px",
            }}
          >
            {graphTitle}
          </h3>
          <div style={{ width: "100%", height: "calc(100vh - 350px)" }}>
            {String(keyword.status2) === "1" ? (
              <ResponsiveContainer>
                <ComposedChart
                  width={"calc(100% - " + gridWidth + ")"}
                  height={"calc(100vh - 350px)"}
                  data={graphData}
                  margin={{ top: 5, right: 5, bottom: 0, left: 50 }}
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis dataKey="name" />
                  <YAxis
                    tickFormatter={(tick) =>
                      tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                  />
                  <Tooltip
                    formatter={(okay) => new Intl.NumberFormat("ko").format(okay)}
                  />
                  <Bar dataKey={"생산수량"} barSize={10} fill="#009900" />
                  <Bar dataKey={"양품수량"} barSize={10} fill="#413ea0" />
                  <Bar dataKey={"불량수량"} barSize={10} fill="#CC0000" />
                </ComposedChart>
              </ResponsiveContainer>
            ) : String(keyword.status2) === "2" || String(keyword.status2) === "3" ? (
              <ResponsiveContainer>
                <ComposedChart
                  data={graphData}
                  margin={{ top: 5, right: 5, bottom: 0, left: 50 }}
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis dataKey="xlabel" interval={0} />
                  <YAxis tickFormatter={(t) => t.toLocaleString("ko-KR")} />
                  <Tooltip
                    labelFormatter={(label, payload) => {
                      if (typeof label === "string" && label.includes(" | ")) {
                        return label.replace(" | ", " / ");
                      }
                      const p = payload && payload[0] && payload[0].payload;
                      if (!p) return String(label ?? "");
                      const left = p.gijun_date ?? p.gijun_month ?? "";
                      const right =
                        p.project_name ??
                        (p.item_name
                          ? p.item_spec
                            ? `${p.item_name} (${p.item_spec})`
                            : p.item_name
                          : "");
                      const text = right ? `${left} / ${right}` : left || String(label ?? "");
                      return text;
                    }}
                    formatter={(v) =>
                      Number(v ?? 0).toLocaleString("ko-KR")
                    }
                  />
                  <Bar dataKey="생산수량" barSize={10} fill="#009900" />
                  <Bar dataKey="양품수량" barSize={10} fill="#413ea0" />
                  <Bar dataKey="불량수량" barSize={10} fill="#CC0000" />
                </ComposedChart>
              </ResponsiveContainer>
            ) : String(keyword.status2) === "4" ? (
              <ResponsiveContainer>
                <ComposedChart
                  width={"calc(100% - " + gridWidth + ")"}
                  height={"calc(100vh - 350px)"}
                  data={graphData}
                  margin={{ top: 5, right: 5, bottom: 0, left: 50 }}
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis dataKey="name" />
                  <YAxis
                    tickFormatter={(tick) =>
                      tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                  />
                  <Tooltip
                    formatter={(okay) => new Intl.NumberFormat("ko").format(okay)}
                  />
                  <Bar dataKey={"사용계획수량"} barSize={15} fill="#009900" />
                  <Bar dataKey={"사용수량"} barSize={15} fill="#413ea0" />
                </ComposedChart>
              </ResponsiveContainer>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineProductionStatistics;
